<template>
    <div>
        <hts-card
            :title="$t('labels.bankingInformation')"
            :loading="loaded">
            <template
                v-if="group.isAdmin || permissions.includes('company_edit_banking')"
                #actions>
                <hts-dropdown
                    :options="dropdownOptions"
                    type="text"
                    :label-only-icon="true"
                    color="theme"
                    size="large"
                    prop-option-key="id"
                    prop-option-label="name"
                    icon="hi-ellipsis-vertical-icon"
                    prop-option-icon="hi-pencil-alt-icon"
                    @click="handleEditBanking" />
            </template>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-5">
                <div>
                    <h3>
                        {{ $t('labels.bankingName') }}
                    </h3>
                    <p class="mt-2">
                        {{ bankingData.bankingName }}
                    </p>
                </div>
                <div>
                    <h3>
                        {{ $t('labels.bankingBranch') }}
                    </h3>
                    <p class="mt-2">
                        {{ bankingData.bankingBranch }}
                    </p>
                </div>
                <div>
                    <h3>
                        {{ $t('labels.accountNumber') }}
                    </h3>
                    <p class="mt-2">
                        {{ bankingData.bankingAccountNumber }}
                    </p>
                </div>
                <div>
                    <h3>
                        {{ $t('labels.accountName') }}
                    </h3>
                    <p class="mt-2">
                        {{ bankingData.accountHolderName }}
                    </p>
                </div>
            </div>
        </hts-card>
        <edit-bank
            :banking-is-selected-to-edit="bankingIsSelectedToEdit"
            :show="showSlideOverEditBanking"
            :size-slide-over="30"
            @close="showSlideOverEditBanking = false"
            @refresh="onRefresh()" />
    </div>
</template>

<script setup lang="ts">
import bankingFormData, { IBankingInformation } from './ignore/imports/banking-form'
import EditBank from './ignore/edit-bank.vue'
import companyPageTabs from '@/data/company/tabs.json'

const store = $store()
const group = store.system.getGroup
const permissions = ref<Array<String>>([])
onMounted(() => {
  permissions.value = group.permissions
})
const route = useRoute()
const companyName = ref('')
const loaded = ref(false)
const showSlideOverEditBanking = ref(false)
const bankingData = ref<IBankingInformation>(bankingFormData.initBanking)
const bankingIsSelectedToEdit = reactive<IBankingInformation>({
  bankingName: '',
  bankingAccountNumber: '',
  bankingBranch: '',
  accountHolderName: ''
})

onBeforeMount(async () => {
  route.meta.pageTabs = companyPageTabs
  await getCompanyInfo()
  companyName.value = store.system.getCompany.name
})
const dropdownOptions = [
  {
    id: 1,
    name: 'Chỉnh sửa',
    icon: 'hi-pencil-alt-icon',
    action: 'editInvoice'
  }
]
const onRefresh = async () => {
  await getCompanyInfo()
}
const handleEditBanking = () => {
  Object.assign(bankingIsSelectedToEdit, bankingData.value)
  showSlideOverEditBanking.value = true
}

const getCompanyInfo = async () => {
  loaded.value = true
  const company = await $api($url.company.getHoldingCompany)
  const data: any = $lodash.get(company, 'data.value')
  const error: any = $lodash.get(company, 'error')

  if (!data.success) {
    const msgError = $lodash.get(error, 'value.data.errors.0', 'Không thể kết nối tới máy chủ')
    $toast().error(msgError)
  } else {
    bankingData.value = data.data.bankingInformation
  }
  loaded.value = false
}
</script>
